module.exports = "<div class=\"tip tip-hide\"> <div class=tip-arrow></div> <div class=tip-inner></div> </div>";


//////////////////
// WEBPACK FOOTER
// ../~/component-tip/template.html
// module id = 2491
// module chunks = 0